import { useCallback, useState } from "react";
import countries from "i18n-iso-countries";

import { useBuilderTheme } from "hooks/use-builder-theme";
import { StripeIcon } from "webapp/ui/smart/buy-screen/buy-screen-style";

// eslint-disable-next-line @typescript-eslint/no-var-requires
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
const COUNTRY_NAMES = countries.getNames("en");

export interface CardInfo {
    nameOnCard: string;
    receiptEmail: string;
    add1: string;
    add2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}

interface Props {
    cardInfo: CardInfo;
    onCardInfoUpdate: (cardInfo: CardInfo) => void;
}

function PaymentInfo(p: Props) {
    const { cardInfo, onCardInfoUpdate } = p;

    const [countrySelected, setCountrySelected] = useState(false);

    const theme = useBuilderTheme();

    const onNameChange = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, nameOnCard: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onEmailChange = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, receiptEmail: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onAdd1Change = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, add1: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onAdd2Change = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, add2: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onCityChange = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, city: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onStateChange = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, state: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onZipChange = useCallback(
        (evt: React.ChangeEvent<HTMLInputElement>) => {
            onCardInfoUpdate({ ...cardInfo, zip: evt.target.value });
        },
        [cardInfo, onCardInfoUpdate]
    );
    const onCountryChange = useCallback(
        (evt: React.ChangeEvent<HTMLSelectElement>) => {
            onCardInfoUpdate({ ...cardInfo, country: evt.target.value });
            setCountrySelected(true);
        },
        [cardInfo, onCardInfoUpdate]
    );

    return (
        <>
            <input
                className="form-input nameInput"
                placeholder="Name on card"
                value={cardInfo.nameOnCard}
                onChange={onNameChange}
            />
            <input
                className="form-input address1"
                placeholder="Address"
                onChange={onAdd1Change}
                value={cardInfo.add1}
            />
            <input
                className="form-input address2"
                placeholder="Address (line 2)"
                onChange={onAdd2Change}
                value={cardInfo.add2}
            />
            <div className="city-zip-container">
                <input className="form-input city" placeholder="City" onChange={onCityChange} value={cardInfo.city} />
                <input
                    className="form-input state"
                    placeholder="State"
                    onChange={onStateChange}
                    value={cardInfo.state}
                />
                <input className="form-input zip" placeholder="Zip" onChange={onZipChange} value={cardInfo.zip} />
            </div>
            <select
                className="form-input-country"
                style={{
                    color: countrySelected ? theme.fgColorDark : "#737383",
                }}
                name="Two-letter country code"
                value={cardInfo.country}
                onChange={onCountryChange}>
                <option value="Country" disabled hidden>
                    Country
                </option>
                {Object.entries(COUNTRY_NAMES)
                    .sort(([, leftNames], [, rightNames]) => {
                        const leftName = Array.isArray(leftNames) ? leftNames[0] : leftNames;
                        const rightName = Array.isArray(rightNames) ? rightNames[0] : rightNames;
                        return leftName.localeCompare(rightName, "en");
                    })
                    .map(([code, names]) => {
                        const name = Array.isArray(names) ? names[0] : names;
                        return (
                            <option key={code} value={code}>
                                {name}
                            </option>
                        );
                    })}
            </select>
            <div className="stripe">
                <StripeIcon />
            </div>
            <div className="send-to-label">Send email receipts to</div>
            <input
                className="form-input emailInput"
                placeholder="Email address for receipts"
                value={cardInfo.receiptEmail}
                onChange={onEmailChange}
            />
        </>
    );
}

export default PaymentInfo;
